import React from "react";
import "../About/About.css";

const About = () => {
  return (
    <div className="about-container">
      <div className="animated-spot spot1"></div>
      <div className="animated-spot spot2"></div>
      <div className="animated-spot spot3"></div>
      {/* Left content */}
      <div className="about-left">
        <h3>Precision in Every Package</h3>
        <h1>From 2011 - 2025</h1>
        <p>
          For over a decade, we've specialized in delivering high-quality
          packaging solutions for orthopedic instruments. Our commitment to
          sterile, secure, and professional packaging ensures every product
          reaches medical professionals with the integrity it was designed with.
          Trusted by leading healthcare brands, we combine innovation with
          precision to exceed industry standards and client expectations.
        </p>
        <div className="post-owner">
          <img src="sd.webp" alt="Director" className="owner-pic" />
          <div className="owner-details">
            <span className="owner-name">Dr. XYZ abc</span>
            <span className="owner-role">Managing Director</span>
          </div>
        </div>
      </div>

      {/* Right side with image grid */}
      <div className="image-grid">
        <div className="solid-circle circle-1"></div>
        <div className="solid-circle circle-2"></div>
        <div className="solid-circle circle-3"></div>

        <div className="image-row">
          <div className="image-tile">
            <img src="/r.webp" alt="Orthopedic Instruments" />
          </div>
          <div className="image-tile middle">
            <img src="/v.webp" alt="Packaging Process" />
          </div>
          <div className="image-tile">
            <img src="/l.webp" alt="Medical Equipment" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
